import React from 'react';
import './Sponsors.css';

function Sponsors() {
  return (
    <div id="sponsors" className="main bgs">
      <h1> This is the sponsors section</h1>
    </div>
  );
}

export default Sponsors;
